<template>
    <v-content>
        <v-container>
            <v-card>
                <v-card-title class="m-0 py-0 px-0">
                    <GmapMap
                            :options="{
                               zoomControl: true,
                               mapTypeControl: false,
                               scaleControl: false,
                               streetViewControl: false,
                               rotateControl: false,
                               fullscreenControl: true,
                               disableDefaultUi: false
                         }"
                            :center="{lat:data.coordinates.latitude, lng:data.coordinates.longitude}"
                            :zoom="15"
                            map-type-id="roadmap"
                            style="width: 100%; height: 300px"
                    >
                        <GmapMarker
                                :position="{lat:data.coordinates.latitude, lng:data.coordinates.longitude }"
                                :clickable="true"
                                :draggable="false"

                        />
                    </GmapMap>
                </v-card-title>
                <template class="mt-2">
                    <h1 class="text-center">Evidencias</h1>
                    <v-container fluid>
                        <v-row>
                            <v-col cols="12" md="4" sm="6"  v-for="(item, index) in images" :key="index">
                               <div v-if="item.type === 'image'">
                                 <a :href="item.filepath" target="_blank">
                                   <v-img  :src="item.filepath"  />
                                 </a>
                               </div>
                                <div v-else>
                                    <video>
                                        <source  :src="item.filepath">
                                    </video>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </template>
            </v-card>
        </v-container>
    </v-content>
</template>

<script>
    import {db} from "../plugins/db";

    export default {
        name: "AlertImages",
        data(){
            return{
                images:[],
                data:{}
            }
        },
        methods:{
           async getData(){
                this.$store.commit('setLoading', true);
                this.images = [];
               const data = await db.doc('alerts/'+ this.$route.params.id).get();
               if (data){
                   this.data = data.data()               }
               const collection = await db.doc('alerts/'+ this.$route.params.id).collection('images').get();
               if (collection){
                   collection.forEach(e => {
                       this.images.push(e.data())
                   });
                   this.$store.commit('setLoading', false);
               }
            }
        },
        created() {
            this.getData();
        }
    }
</script>

<style scoped>

</style>
